import Link from "next/link";
import { useSelector } from "react-redux";

import { useStoreContext } from "@components/store/provider";

import { getMenu } from "@store/selectors/menu";
import { getMenuItemRoute } from "@constants/routes";
import { getSelectedMenuItem, getSubcategories } from "@helpers/menu";

import styles from "./main.module.scss";

const SidebarCategoryListing = ({ linkClassName = "" }) => {
  const menu = useSelector(getMenu);
  const { storeBasePath, category, subCategory } = useStoreContext();

  if (menu.children?.length === 0) return null;

  const parentCategory = getSelectedMenuItem(menu, category) || {
    children: [],
  };

  const subCategories = getSubcategories(parentCategory);

  const renderSubCategory = (item) => {
    const slug = getMenuItemRoute({
      storeBasePath,
      category: item.code,
    });
    let className = item.code === subCategory ? styles.active : "";
    if (item.id)
      return (
        <div key={item.id} className={`${className} ${styles.leftSideBarListItem}`}>
          <Link href={slug} passHref className={linkClassName} prefetch={false}>
            {item.name}
          </Link>
        </div>
      );
  };

  return subCategories.map(renderSubCategory);
};

export default SidebarCategoryListing;
